import { useState, useCallback, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ErrorMessage, SuccessMessage } from 'ui/shared/messages';
import { IconTextField } from 'ui/shared/controls';

require('./ResetPasswordForm.css');

export type Props = {
    submitting: boolean;
    successMessage: string;
    errorMessage: string;
    onSubmit(loginOrEmailAddress: string): void;
};

export const ResetPasswordForm = ({ submitting, errorMessage, successMessage, onSubmit }: Props) => {
    const { t } = useTranslation();

    const [ login, setLogin ] = useState('');

    const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLogin(login => {
            onSubmit(login);
            return login;
        });
        return false;
    }, [ onSubmit, setLogin ]);

    return (
        <form
            id="reset-password-form"
            onSubmit={ handleSubmit }
            className={ `ui grid form${errorMessage ? ' error' : ''}${submitting ? ' loading' : ''}` }
        >
            <div className="column">
                <p>{ t('RESET_PASSWORD.INSTRUCTIONS')}</p>
                <div>
                    <IconTextField
                        id="reset-password-login"
                        name="login"
                        labelKey="RESET_PASSWORD.FIELD.LOGIN"
                        icon="user"
                        required={ true }
                        autoFocus={ true }
                        value={ login }
                        onChange={ e => setLogin(e.currentTarget.value) }
                    />
                </div>
                <div style={ { marginTop: '20px', textAlign: 'right' } }>
                    <Link to="/login" style={ { marginRight: '20px' } } tabIndex={ -1 }>
                        { t('COMMAND.CANCEL') }
                    </Link>
                    <button className="ui primary submit button" type="submit" disabled={ submitting }>
                        <div className="visible content">{ t('COMMAND.RESET_PASSWORD') }</div>
                    </button>
                </div>
                <ErrorMessage message={ errorMessage }/>
                <SuccessMessage message={ successMessage }/>
            </div>
        </form>
    );
};
